var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('h1',[_vm._v("Formulários Customizados")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }